import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Card, Modal, Button } from 'ui';
import { BetaFeedback } from 'components/BetaProgram';
import EMAILS from 'constants/emails';
import ZoomContext from 'components/InPersonTraining/shared/ZoomContext';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';
import AddSessionForm from '../Session/AddSessionForm';
import IndividualSession from './IndividualSession';

class MultiSession extends Component {
  state = {
    addingSession: false,
    isSingleSessionView: false,
    currentSession: null,
  };

  toggleAddingSession = () => {
    this.setState(state => ({ addingSession: !state.addingSession }));
  };

  render() {
    const { sessions, eventId, isArchived, meta, sessionCount } = this.props;
    const { addingSession, isSingleSessionView, currentSession } = this.state;
    const { currentUser, currentCompany, zoomClientId } = meta;
    const sortedSessions = sessions.sort((a, b) =>
      a.start_time > b.start_time ? 1 : -1,
    );
    return (
      <ZoomContext.Provider value={{ zoomClientId }}>
        <Modal
          shown={addingSession}
          onDismiss={this.toggleAddingSession}
          canClickAway={false}
          className="w-725p Modal-shell"
          enableFloatingDismiss
        >
          <Modal.Content>
            <AddSessionForm
              eventId={eventId}
              currentUser={currentUser}
              currentCompany={currentCompany}
              onDismiss={this.toggleAddingSession}
              rsvpType={this.props.rsvpType}
              sessionCount={this.props.sessionCount}
            />
          </Modal.Content>
        </Modal>
        {!currentSession && !isSingleSessionView && (
          <>
            <Card className="EventSession pb-24">
              <>
                <Card.Content className="fz-base">
                  <div className="d-f jc-sb ai-fs">
                    <div className="d-f pl-24 pt-24 ai-c mb-32">
                      <Text variant={TEXT_VARIANTS.SUBHEADER_BOLD}>
                        {t('in_person_training.event_overview.sessions.title')}
                      </Text>
                      <span className="EventSessionCount">{sessionCount}</span>
                    </div>
                    <div className="d-f pr-24 pt-24">
                      <Button
                        icon="add"
                        small
                        fullWidth
                        className="fz-16"
                        disabled={isArchived || sessionCount >= 10}
                        // The flow for adding a new Session will be updated in another story.
                        // The old flow is being left in for now to make testing easier.
                        onClick={this.toggleAddingSession}
                      >
                        {t('in_person_training.event_overview.session.add')}
                      </Button>
                    </div>
                  </div>
                  {sortedSessions.map((session, index) => {
                    const sessionIndex = index + 1;
                    return (
                      <div key={session.id} className="ml-20 mr-20 mb-20">
                        <Link
                          to={`/in_person_training/events/${eventId}/sessions/${session.id}`}
                        >
                          <Button
                            type="button"
                            className="EventSessionItem"
                            key={session.id}
                          >
                            <IndividualSession
                              session={session}
                              eventId={eventId}
                              defaultSessionName={t(
                                'in_person_training.event_overview.session.default_session_name',
                                {
                                  session_index: sessionIndex,
                                },
                              )}
                            />
                          </Button>
                        </Link>
                      </div>
                    );
                  })}
                  <BetaFeedback
                    className="d-f ml-24"
                    recipient={EMAILS.EVENTS_FEEDBACK}
                    betaFeatureName="Mult Session Events"
                  />
                </Card.Content>
              </>
            </Card>
          </>
        )}
      </ZoomContext.Provider>
    );
  }
}

export default withRouter(MultiSession);
